/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface NicePaymentsControllerReceiveWebhookBodyRequest {
  /** 결제결과코드: 0000 : 성공 / 그외 실패 */
  resultCode?: string | null;
  /** 결제결과메시지 */
  resultMsg?: string | null;
  /** 결제 승인 키: 최초 승인(가상계좌-채번)에 성공한 원거래의 NICEPAY 거래키 입니다. */
  tid?: string | null;
  /** 취소 거래 키: NICEPAY가 발행하는 취소 응답 TID (부분취소시 tid와 다른 값이 응답됨) */
  cancelledTid?: string | null;
  /** 상점 거래 고유번호 */
  orderId?: string | null;
  /** 응답전문생성일시 ISO 8601 형식 */
  ediDate?: string | null;
  /** 위변조 검증 데이터: 유효한 거래건에 한하여 응답 */
  signature?: string | null;
  /** 결제 처리상태: paid:결제완료, ready:준비됨, failed:결제실패, cancelled:취소됨, partialCancelled:부분 취소됨, expired:만료됨 */
  status?: "paid" | "ready" | "failed" | "cancelled" | "partialCancelled" | "expired" | "" | null;
  /** 결제완료시점 ISO 8601 형식: 결제완료가 아닐 경우 0 */
  paidAt?: string | null;
  /** 결제실패시점 ISO 8601 형식: 결제실패가 아닐 경우 0 */
  failedAt?: string | null;
  /** 결제취소시점 ISO 8601 형식: 결제취소가 아닐 경우 0 */
  cancelledAt?: string | null;
  /** 결제수단: card:신용카드, vbank:가상계좌, bank:계좌이체, cellphone:휴대폰, naverpay:네이버페이, kakaopay:카카오페이, samsungpay:삼성페이 */
  payMethod?: "card" | "vbank" | "bank" | "cellphone" | "naverpay" | "kakaopay" | "samsungpay" | "" | null;
  /** 결제 금액 */
  amount?: number | null;
  /** 취소 가능 잔액: 부분취소 거래인경우, 전체금액에서 현재까지 취소된 금액을 차감한 금액. */
  balanceAmt?: number | null;
  /** 상품명 */
  goodsName?: string | null;
  /** 상점 정보 전달용 예비필드: returnUrl로 redirect되는 시점에 반환 됩니다. JSON string format으로 이용하시기를 권고 드립니다. 단, 큰따옴표(")는 이용불가 */
  mallReserved?: string | null;
  /** 에스크로 거래 여부: false:일반거래 / true:에스크로 거래 */
  useEscrow?: boolean | null;
  /** 결제승인화폐단위: KRW:원화, USD:미화달러, CNY:위안화 */
  currency?: "KRW" | "USD" | "CNY" | "" | null;
  /** pc:PC결제, mobile:모바일결제 */
  channel?: "PC" | "MOBILE" | "pc" | "mobile" | null;
  /** 제휴사 승인 번호: 신용카드, 계좌이체, 휴대폰 */
  approveNo?: string | null;
  /** 구매자 명 */
  buyerName?: string | null;
  /** 구매자 전화번호 */
  buyerTel?: string | null;
  /** 구매자 이메일 */
  buyerEmail?: string | null;
  /** 현금영수증 발급여부: true:발행 / false:미발행 */
  issuedCashReceipt?: boolean | null;
  /** 매출전표 확인 URL */
  receiptUrl?: string | null;
  /** 상점에서 관리하는 사용자 아이디 */
  mallUserId?: string | null;
  coupon?: {
    /** 즉시할인 적용된 금액 */
    couponAmt: number;
  } | null;
  cashReceipts?:
    | {
        /** 현금영수증 TID */
        receiptTid: string;
        /** 연관된 원 승인/취소 거래 TID */
        orgTid: string;
        /** 발급진행 상태 */
        status: string;
        /** 현금영수증 발행 총금액 */
        amount: number;
        /** 현금영수증 전체 금액중에서 면세금액 */
        taxFreeAmt: number;
        /** 현금영수증 타입: individual:개인 소득공제용, company:사업자 지출증빙용 */
        receiptType: string;
        /** 현금영수증 국세청 발행번호 */
        issueNo: string;
        /** 현금영수증 매출전표 확인 URL */
        receiptUrl: string;
      }[]
    | null;
  bank?: {
    /** 결제은행코드 */
    bankCode: string;
    /** 결제은행명 */
    bankName: string;
  } | null;
  vbank?: {
    /** 입금받을 가상계좌 은행코드 */
    vbankCode: string;
    /** 입금받을 가상계좌 은행명 */
    vbankName: string;
    /** 입금받을 가상계좌 번호 */
    vbankNumber: string;
    /** 가상계좌 입금 만료일 ISO 8601 */
    vbankExpDate: string;
    /** 입금받을 가상계좌 예금주명 */
    vbankHolder: string;
  } | null;
  card?: {
    /** 신용카드사별 코드 */
    cardCode: string;
    /** 결제 카드사 이름 */
    cardName: string;
    /** 카드번호: 앞 6자 마지막 4자를 제외한 가운데 숫자 마스킹 처리됨 */
    cardNum?: string | null;
    /** 할부개월: 0:일시불, 2:2개월, 3:3개월 … */
    cardQuota?: number | null;
    /** 상점분담무이자 여부: true:무이자, false:일반 */
    isInterestFree: boolean;
    /** 카드 구분: credit:신용, check:체크 */
    cardType?: string | null;
    /** 부분취소 가능 여부: true:가능, false:불가능 */
    canPartCancel: boolean | null;
    /** 매입카드사코드 */
    acquCardCode: string;
    /** 매입카드사명 */
    acquCardName: string;
  };
  cancels?: {
    /** 승인 취소 거래번호 */
    tid: string;
    /** 취소금액 */
    amount?: number | null;
    /** 취소된 시각 ISO 8601 */
    cancelledAt?: string | null;
    /** 취소사유 */
    reason?: string | null;
    /** 취소에 대한 매출전표 확인 URL */
    receiptUrl?: string | null;
    /** 쿠폰 취소금액 */
    couponAmt?: number | null;
  }[];
}

export interface NicePaymentsControllerRegistBillingCardBodyRequest {
  cardNo: string;
  expYear: string;
  expMonth: string;
  idNo: string;
  cardPw: string;
  cardOwnerType: "PERSONAL" | "CORP";
  billingEmail: string;
  label?: string | null;
  /** @default false */
  isDefault?: boolean;
}

export interface NicePaymentsControllerRegistBillingCardResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    bid: string;
    maskedCardNumber: string;
    cardCode?: string | null;
    cardName?: string | null;
    cardOwnerType: "PERSONAL" | "CORP";
    billingEmail: string;
    status: string;
    isDefault: boolean;
    label?: string | null;
    createdAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NicePaymentsControllerFindBillingCardsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    bid: string;
    maskedCardNumber: string;
    cardCode?: string | null;
    cardName?: string | null;
    cardOwnerType: "PERSONAL" | "CORP";
    billingEmail?: string | null;
    status: string;
    isDefault: boolean;
    label?: string | null;
    createdAt?: string | null;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NicePaymentsControllerFindOneBillingCardResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    bid: string;
    maskedCardNumber: string;
    cardCode?: string | null;
    cardName?: string | null;
    cardOwnerType: "PERSONAL" | "CORP";
    billingEmail?: string | null;
    status: string;
    isDefault: boolean;
    label?: string | null;
    createdAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NicePaymentsControllerDeleteBillingCardResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    resultCode: string;
    resultMsg: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NicePaymentsControllerSetDefaultBillingCardResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    bid: string;
    maskedCardNumber: string;
    cardCode?: string | null;
    cardName?: string | null;
    cardOwnerType: "PERSONAL" | "CORP";
    billingEmail?: string | null;
    status: string;
    isDefault: boolean;
    label?: string | null;
    createdAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface NicePaymentsCardBenefitControllerGetCurrentCardBenefitResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    yearMonth: string;
    content: string;
    updatedAt: string;
  } | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type NicePaymentsControllerReceiveWebhookData = any;

export type NicePaymentsControllerRegistBillingCardData = NicePaymentsControllerRegistBillingCardResponse;

export type NicePaymentsControllerFindBillingCardsData = NicePaymentsControllerFindBillingCardsResponse;

export type NicePaymentsControllerFindOneBillingCardData = NicePaymentsControllerFindOneBillingCardResponse;

export type NicePaymentsControllerDeleteBillingCardData = NicePaymentsControllerDeleteBillingCardResponse;

export type NicePaymentsControllerSetDefaultBillingCardData = NicePaymentsControllerSetDefaultBillingCardResponse;

export type NicePaymentsCardBenefitControllerGetCurrentCardBenefitData =
  NicePaymentsCardBenefitControllerGetCurrentCardBenefitResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description Nicepayments 웹훅 수신
     *
     * @tags NicePayments
     * @name NicePaymentsControllerReceiveWebhook
     * @summary Nicepayments 웹훅 수신
     * @request POST:/v3/api/nicepayments/webhook
     * @secure
     * @response `200` `NicePaymentsControllerReceiveWebhookData` 成功响应
     */
    nicePaymentsControllerReceiveWebhook: (
      data: NicePaymentsControllerReceiveWebhookBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<NicePaymentsControllerReceiveWebhookData, any>({
        path: `/v3/api/nicepayments/webhook`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 빌링카드 등록 (빌키 발급)
     *
     * @tags NicePayments-Billing
     * @name NicePaymentsControllerRegistBillingCard
     * @summary 빌링카드 등록
     * @request POST:/v3/api/nicepayments/billing/regist
     * @secure
     * @response `200` `NicePaymentsControllerRegistBillingCardData` success
     */
    nicePaymentsControllerRegistBillingCard: (
      data: NicePaymentsControllerRegistBillingCardBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<NicePaymentsControllerRegistBillingCardData, any>({
        path: `/v3/api/nicepayments/billing/regist`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 빌링카드 목록 조회
     *
     * @tags NicePayments-Billing
     * @name NicePaymentsControllerFindBillingCards
     * @summary 등록된 빌링카드 목록 조회
     * @request GET:/v3/api/nicepayments/billing/cards
     * @secure
     * @response `200` `NicePaymentsControllerFindBillingCardsData` success
     */
    nicePaymentsControllerFindBillingCards: (params: RequestParams = {}) =>
      this.request<NicePaymentsControllerFindBillingCardsData, any>({
        path: `/v3/api/nicepayments/billing/cards`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 빌링카드 단건 조회
     *
     * @tags NicePayments-Billing
     * @name NicePaymentsControllerFindOneBillingCard
     * @summary 빌링카드 단건 조회
     * @request GET:/v3/api/nicepayments/billing/cards/{id}
     * @secure
     * @response `200` `NicePaymentsControllerFindOneBillingCardData` success
     */
    nicePaymentsControllerFindOneBillingCard: (id: string, params: RequestParams = {}) =>
      this.request<NicePaymentsControllerFindOneBillingCardData, any>({
        path: `/v3/api/nicepayments/billing/cards/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 빌링카드 삭제
     *
     * @tags NicePayments-Billing
     * @name NicePaymentsControllerDeleteBillingCard
     * @summary 빌링카드 삭제
     * @request DELETE:/v3/api/nicepayments/billing/cards/{id}
     * @secure
     * @response `200` `NicePaymentsControllerDeleteBillingCardData` success
     */
    nicePaymentsControllerDeleteBillingCard: (id: string, params: RequestParams = {}) =>
      this.request<NicePaymentsControllerDeleteBillingCardData, any>({
        path: `/v3/api/nicepayments/billing/cards/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 기본 결제카드 변경
     *
     * @tags NicePayments-Billing
     * @name NicePaymentsControllerSetDefaultBillingCard
     * @summary 기본 결제카드 변경
     * @request PATCH:/v3/api/nicepayments/billing/cards/{id}/default
     * @secure
     * @response `200` `NicePaymentsControllerSetDefaultBillingCardData` success
     */
    nicePaymentsControllerSetDefaultBillingCard: (id: string, params: RequestParams = {}) =>
      this.request<NicePaymentsControllerSetDefaultBillingCardData, any>({
        path: `/v3/api/nicepayments/billing/cards/${id}/default`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 나이스페이 무이자할부 정보
     *
     * @tags V3-NicePayments-CardBenefit
     * @name NicePaymentsCardBenefitControllerGetCurrentCardBenefit
     * @summary 당월 무이자할부 정보 조회
     * @request GET:/v3/api/nicepayments/card-benefit
     * @secure
     * @response `200` `NicePaymentsCardBenefitControllerGetCurrentCardBenefitData` success
     */
    nicePaymentsCardBenefitControllerGetCurrentCardBenefit: (params: RequestParams = {}) =>
      this.request<NicePaymentsCardBenefitControllerGetCurrentCardBenefitData, any>({
        path: `/v3/api/nicepayments/card-benefit`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
